let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1zoBu")).then(() => parcelRequire('4QNfT'));